
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';

//部门
export async function getDepartmentsList(params) {
    return post(erpserver+'/task/getDepartmentsList', params, true)
}
//车间
export async function getWorkshopsList(params) {
    return post(erpserver+'/task/getWorkshopsList', params, true)
}
//任务详情列表
export async function getTaskDetailList(params) {
    return post(erpserver+'/task/getTaskDetailList', params, true)
}
export async function getTaskDetailFileList(params) {
    return post(erpserver+'/task/getTaskDetailFileList', params, true)
}
export async function getShiftClasses(params) {
    return post(erpserver+'/shift/getShiftClasses', params, true)
}